import "css/style.css"
import {lazyLoading} from "./lazyload/lazyload-init"
import "@components/main-nav"
import "@components/main-header/main-header"
import "js/same-height/same-height"
import "js/print-button/print-button"

window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadFancybox() {
  await import("js/fancybox/fancybox-gallery-id-generator")
  if (document.querySelectorAll(".entry-content .kt-img-link, .entry-content a").length) {
    await import("@components/wordpress/entry-content/js/entry-content-fancybox-image")
  }
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("js/fancybox/fancybox")
  }
}
loadFancybox()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./swiper/swiper")
  }
}
loadSwiper()

async function loadOverlayScrollbars() {
  if (document.querySelectorAll(".u-scrollbar").length) {
    await import("js/overlayscrollbars")
  }
}
loadOverlayScrollbars()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("js/slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadFlatpickr() {
  if (document.querySelectorAll(".flatpicker").length) {
    await import("js/flatpickr")
  }
}
loadFlatpickr()

async function loadModals() {
  if (document.querySelectorAll(".c-modal").length) {
    await import("@components/modal/modal")
  }
}
loadModals()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file").length) {
    await import("@components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadPasswordField() {
  if (document.querySelectorAll(".f-text.--password").length) {
    await import("@components/fields/text-field/text-field--password")
  }
}
loadPasswordField()

async function loadTextField() {
  if (document.querySelectorAll(".f-text, .f-textarea").length) {
    await import("@components/fields/text-field/text-field")
  }
}
loadTextField()

async function loadCalendar() {
  if (document.querySelectorAll(".s-calendar").length) {
    await import("@components/sections/calendar-section/calendar-section")
  }
}
loadCalendar()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("@components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadNotification() {
  if (document.querySelectorAll(".i-notification").length) {
    await import("@components/items/notification-item/notification-item")
  }
}
loadNotification()

async function loadFaqItem() {
  if (document.querySelectorAll(".i-faq").length) {
    await import("@components/items/faq-item/faq-item")
  }
}
loadFaqItem()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("@components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadBaseForm() {
  if (document.querySelectorAll("form.--validate").length) {
    await import("@components/base-form/base-form")
  }
}
loadBaseForm()

async function loadScrollUp() {
  if (document.querySelectorAll(".c-scroll-up").length) {
    await import("@components/scroll-up/scroll-up")
  }
}
loadScrollUp()

async function loadExternalSvgLoader() {
  if (document.querySelectorAll(".c-svg").length) {
    await import("@components/svg")
  }
}
loadExternalSvgLoader()

async function loadMenuItem() {
  if (document.querySelectorAll(".i-menu").length) {
    await import("@components/items/menu-item/menu-item")
  }
}
loadMenuItem()

async function loadWordpressMenuItem() {
  if (document.querySelectorAll(".menu-item-has-children, .page_item_has_children").length) {
    await import("@components/wordpress/items/menu-item/menu-item")
  }
}
loadWordpressMenuItem()

async function loadWordpressAside() {
  if (document.querySelectorAll(".widget_categories, .widget_nav_menu, .widget_pages").length) {
    await import("@components/wordpress/aside/aside")
  }
}
loadWordpressAside()

async function loadWordpressEntryContent() {
  if (document.querySelectorAll(".entry-content iframe").length) {
    await import("@components/wordpress/entry-content/js/entry-content-iframe")
  }
  if (document.querySelectorAll(".entry-content table").length) {
    await import("@components/wordpress/entry-content/js/entry-content-width-height")
  }
}
loadWordpressEntryContent()

async function loadInfiniteInterprets() {
  if (document.querySelectorAll(".g-interprets.--infinite").length) {
    await import("@components/groups/interprets-group/interprets-group--infinite")
  }
}
loadInfiniteInterprets()

async function loadHeroIntro() {
  if (document.querySelectorAll(".s-hero-intro__video video.--js-hero-video").length) {
    await import("@components/sections/hero-intro-section/hero-intro-section")
  }
}
loadHeroIntro()

async function loadShareBar() {
  if (document.querySelectorAll(".c-share-bar").length) {
    await import("@components/share-bar/share-bar")
  }
}
loadShareBar()

async function loadToggler() {
  if (document.querySelectorAll("[data-toggle-trigger]").length) {
    await import("js/toggler/toggler")
  }
}
loadToggler()

async function counter() {
  if (document.querySelectorAll(".c-counter").length) {
    await import("@components/counter/counter")
  }
}
counter()

async function loadFaqsFilter() {
  if (document.querySelectorAll(".s-faqs__content.--has-filters").length) {
    await import("@components/sections/faq-section/faq-section")
  }
}
loadFaqsFilter()

async function loadGoOut() {
  if (document.querySelectorAll(".s-tickets__goout").length) {
    await import("@components/sections/tickets-section/tickets-section--goout")
  }
}
loadGoOut()

async function loadTickets() {
  if (document.querySelectorAll(".i-ticket").length) {
    await import("@components/items/ticket-item/ticket-item")
  }
}
loadTickets()

async function loadCheckboxAutosubmit() {
  if (document.querySelectorAll(".--autosubmit-checkbox").length) {
    await import("js/checkbox-autosubmit/checkbox-autosubmit")
  }
}
loadCheckboxAutosubmit()

async function loadProgramTimeline() {
  if (document.querySelectorAll(".s-program-timeline__scroll").length) {
    await import("@components/sections/program-timeline-section/program-timeline-section")
  }
}

async function loadProgram() {
  if (document.querySelectorAll(".s-program").length) {
    await import("@components/sections/program-section/program-section")
  }
}
loadProgramTimeline().then(() => loadProgram())

async function loadFilterList() {
  if (document.querySelectorAll(".js-filter-list").length) {
    await import("./filter/filter-list")
  }
}

loadFilterList()

async function loadFilterClear() {
  if (document.querySelectorAll(".js-filter-clear").length) {
    await import("./filter/filter-clear")
  }
}
loadFilterClear()

async function loadAccordionsGroup() {
  if (document.querySelectorAll(".g-accordions").length) {
    await import("@components/groups/accordions-group/accordions-group")
  }
}
loadAccordionsGroup()

async function loadVivenu() {
  await import("./vivenu")
}

loadVivenu()

async function loadGallerySection() {
  if (document.querySelectorAll(".s-gallery").length) {
    await import("@components/sections/gallery-section/gallery-section")
  }
}
loadGallerySection()
